export default "__VITE_ASSET__BlJEKq9l__"